module.exports = __webpack_public_path__ + "img/Pot3.b972c41b.svg";